import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c10bf2d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7c10bf2d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10bf2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c10bf2d')) {
      api.createRecord('7c10bf2d', component.options)
    } else {
      api.reload('7c10bf2d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7c10bf2d&scoped=true", function () {
      api.rerender('7c10bf2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/layouts/VabLayoutComprehensive/index.vue"
export default component.exports